/**
 * @generated SignedSource<<ea6fcba3c0fad565a61eac85320a6144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUEANType = "CODE128" | "CODE39" | "EAN";
export type PLUUpdateProductInput = {
  deleteEanCode?: boolean | null;
  deletePluCode?: boolean | null;
  setActive?: boolean | null;
  setCategoryId?: string | null;
  setEanCode?: string | null;
  setEanType?: PLUEANType | null;
  setImageId?: string | null;
  setPluCode?: string | null;
  setTitle?: string | null;
};
export type PLUProductEditScreenUpdateMutation$variables = {
  categoryId: string;
  id: string;
  input: PLUUpdateProductInput;
};
export type PLUProductEditScreenUpdateMutation$data = {
  readonly pluCategory: {
    readonly updateProduct: {
      readonly pluProduct: {
        readonly category: {
          readonly id: string;
          readonly products: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PLUProductItem_PLUProduct">;
          }>;
        };
        readonly eanCode: string | null;
        readonly id: string;
        readonly image: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
        } | null;
        readonly pluCode: string | null;
        readonly title: string;
      };
      readonly previousPLUCategory: {
        readonly id: string;
        readonly products: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PLUProductItem_PLUProduct">;
        }>;
      };
    } | null;
  } | null;
};
export type PLUProductEditScreenUpdateMutation = {
  response: PLUProductEditScreenUpdateMutation$data;
  variables: PLUProductEditScreenUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "categoryId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eanCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pluCode",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PLUProduct",
    "kind": "LinkedField",
    "name": "products",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PLUProductItem_PLUProduct"
      }
    ],
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v13 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PLUProduct",
    "kind": "LinkedField",
    "name": "products",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eanType",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PLUCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageSize",
            "kind": "LinkedField",
            "name": "sizes",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUProductEditScreenUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PLUUpdateProductPayload",
            "kind": "LinkedField",
            "name": "updateProduct",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUProduct",
                "kind": "LinkedField",
                "name": "pluProduct",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "Image_image"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "previousPLUCategory",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUProductEditScreenUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PLUUpdateProductPayload",
            "kind": "LinkedField",
            "name": "updateProduct",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUProduct",
                "kind": "LinkedField",
                "name": "pluProduct",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "previousPLUCategory",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "386a72d349852a7fa24f5f7278a765d8",
    "id": null,
    "metadata": {},
    "name": "PLUProductEditScreenUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PLUProductEditScreenUpdateMutation(\n  $categoryId: ID!\n  $id: ID!\n  $input: PLUUpdateProductInput!\n) {\n  pluCategory(id: $categoryId) {\n    updateProduct(id: $id, input: $input) {\n      pluProduct {\n        id\n        title\n        eanCode\n        pluCode\n        image {\n          id\n          ...Image_image\n        }\n        category {\n          id\n          products {\n            ...PLUProductItem_PLUProduct\n            id\n          }\n        }\n      }\n      previousPLUCategory {\n        id\n        products {\n          ...PLUProductItem_PLUProduct\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment PLUProductItemBody_PLUProduct on PLUProduct {\n  id\n  title\n  active\n  category {\n    ...PLUProductItemCategoryTag_PLUCategory\n    id\n  }\n  imageUrl\n  image {\n    id\n    sizes {\n      width\n      id\n    }\n    ...Image_image\n  }\n}\n\nfragment PLUProductItemCategoryTag_PLUCategory on PLUCategory {\n  id\n  color\n  title\n}\n\nfragment PLUProductItemFooter_PLUProduct on PLUProduct {\n  pluCode\n  eanCode\n  eanType\n}\n\nfragment PLUProductItem_PLUProduct on PLUProduct {\n  id\n  ...PLUProductItemFooter_PLUProduct\n  ...PLUProductItemBody_PLUProduct\n}\n"
  }
};
})();

(node as any).hash = "f29d04a5dcc68c53b61d4cf34efa65e1";

export default node;
